import Contact7 from './Contact7'
export default Contact7
